import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useButton } from '../../hooks';
const Button = forwardRef(({ as: Element = 'button', children, ...rest }, ref) => {
    const { a11yProps, htmlProps } = useButton({ as: Element });
    return (_jsx(Element, { ref: ref, ...a11yProps, ...htmlProps, ...rest, children: children }));
});
Button.displayName = 'Button';
export { Button };
//# sourceMappingURL=Button.js.map